import { createElement, useCallback, useMemo, ReactElement } from 'react';
import { useGetMediasById } from '@sendible/frontendv2/src/models/medias';
import { isPdfMedia, transformLinks } from './utils';

export const useCalendarMediaList = (calendarMedias: CalendarMedia[], enabled: boolean): Media[] => {
  const twMediaIds = useMemo(
    () => (enabled ? [...new Set(calendarMedias.map((m) => m.twMediaId).filter((id): id is number => id != null))] : []),
    [enabled, calendarMedias]
  );
  const { data: twMediaDetails } = useGetMediasById(twMediaIds);

  const twMediaMap = useMemo(() => {
    const map = new Map<number, MediaType>();

    twMediaDetails?.forEach((d) => map.set(d.id, d));

    return map;
  }, [twMediaDetails]);

  return useMemo(
    () =>
      calendarMedias.map((media) => {
        let name = media.url.split('?')[0].split('#')[0].split('/').pop() || 'file';

        if (media.twMediaId != null) {
          const detail = twMediaMap.get(media.twMediaId);

          const detailName = detail?.name;

          if (detailName) name = detailName;
        }

        return {
          url: media.url,
          type: isPdfMedia(media) ? 'pdf' : media.type === 'Gif' ? 'image' : (media.type.toLowerCase() as Media['type']),
          id: media.id,
          isGif: media.type === 'Gif',
          name,
          downloadUrl: media.url,
        };
      }),
    [calendarMedias, twMediaMap]
  );
};

export const useRenderWithLinks = () =>
  useCallback(
    (text: string): (string | ReactElement)[] =>
      transformLinks<string | ReactElement>(
        text,
        (s) => s,
        (href, display, key) =>
          createElement(
            'a',
            {
              key,
              href,
              target: '_blank',
              rel: 'noopener noreferrer',
              onClick: (e: { stopPropagation: () => void }) => e.stopPropagation(),
            },
            display
          )
      ),
    []
  );
